export default __webpack_public_path__ + "assets/models/b5225491f8bbc5dc638164db0b3d5543.glb";